import { ViewModel } from './model';
import html from './template.html';
import './style.less';



ko.components.register('foquz-stats-item', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      let $element = $(element);
      element.classList.add('foquz-stats-item');

      if (ko.unwrap(params.noRightBorder)) {
        element.classList.add('foquz-stats-item--no-right-border');
      }

      return new ViewModel(params, element);
    },
  },
  template: html,
});
